//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import cmFooter from '@/components/cmFooter.vue'
export default {
  name: 'driver',
  components: {
      cmFooter
  },
  data () {
    return {
      info:{},
      nav:[
          {
          title:'取件',
          path:'/pickup',
          auth:'pickup',
          img:'/static/images/pickup.png',
        },
         {
          title:'出厂',
          path:'/outFactory',
          auth:'outFactory',
          img:'/static/images/out_factory.png',
        },
         {
          title:'到站',
          path:'/arrival',
          auth:'arrival',
          img:'/static/images/arrival.png',
        },
        {
          title:'待取件',
          path:'/waitPickup/0',
          auth:'waitPickup',
          img:'/static/images/wait_pickup.png',
        },
        {
          title:'已取件',
          path:'/pickuped',
          auth:'pickuped',
          img:'/static/images/pickuped.png',
        },
        {
          title:'已到站',
          path:'/arrivaled',
          auth:'arrivaled',
          img:'/static/images/arrivaled.png',
        },
         {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
        {
          title:'订单查询',
          path:'/searchOrder',
          auth:'searchOrder',
          img:'/static/images/searchOrder.png',
        },
        {
          title:'修改扎带码',
          path:'/editBag',
          auth:'editBag',
          img:'/static/images/feedback.png',
        },
      ]
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getCount();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  },
  methods:{
    getCount(){
      this.$api.driverData({}).then((res)=>{
        this.info = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/driver.vue